// client/src/lib/hooks/useAuth.ts
import { useState } from "react";

export type LoginPayload = { email: string; password: string };
export type User = {
  id: string; email: string; role: "admin" | "team" | "client";
  first_name: string; last_name: string; profile_pic_url?: string | null;
};

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function login(payload: LoginPayload) {
    setLoading(true); setError(null);
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(`Login failed: ${res.status}`);
      const data: User = await res.json();
      setUser(data);
    } catch (e:any) { setError(e.message); }
    finally { setLoading(false); }
  }

  async function logout() {
    setLoading(true); setError(null);
    try {
      await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
      setUser(null);
    } catch (e:any) { setError(e.message); }
    finally { setLoading(false); }
  }

  async function me() {
    setLoading(true); setError(null);
    try {
      const res = await fetch("/api/auth/me", { credentials: "include" });
      if (res.ok) setUser(await res.json());
    } catch (e:any) { setError(e.message); }
    finally { setLoading(false); }
  }

  return { user, loading, error, login, logout, me };
}
